<template>
    <component
        :is="inDialog ? 'div' : BaseCard"
        v-bind="inDialog ? {} : { theme: 'cream', radius: 'lgr', padding: 'none' }"
        class="flex flex-col items-center"
        :class="inDialog ? 'gap-4' : 'gap-6 p-6'">
        <ReflectionIcon kind="sixty" size="hero" />
        <div class="flex flex-col gap-2.5 w-full">
            <h2 v-if="!inDialog" class="display-small-serif text-center text-ink">{{ hideStart ? t("reflections.sixty.howItWorksTitle") : "Start a 360" }}</h2>
            <p class="body text-ink-muted">
                A short, anonymous read on how your peers, reports, and manager see you — turned into two or three concrete goals. Setup takes about 3 minutes.
            </p>
        </div>

        <ol class="flex flex-col gap-5 w-full">
            <li v-for="step in steps" :key="step.n" class="flex items-start gap-4">
                <span class="flex items-center justify-center w-6.25 h-6.25 shrink-0 rounded-full bg-border scaffold-body-small text-ink">
                    {{ step.n }}
                </span>
                <p class="scaffold-body text-ink-muted">
                    <span class="font-semibold text-ink">{{ step.title }}</span>
                    {{ step.body }}
                </p>
            </li>
        </ol>

        <BaseButton v-if="!inDialog && !hideStart" type="button" theme="primary" size="sm" class="whitespace-nowrap" @click="emit('start')">Launch</BaseButton>
    </component>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";
import { useI18n } from "vue-i18n";

defineProps<{ inDialog?: boolean; hideStart?: boolean }>();
const { t } = useI18n();

const emit = defineEmits<{ (event: "start"): void }>();

const steps = [
    { n: 1, title: "Invite your raters:", body: "peers, direct reports and manager" },
    { n: 2, title: "They answer", body: "a short set of questions, anonymously." },
    { n: 3, title: "Get themes and set goals", body: "a report of key themes and create goals" },
];
</script>
